<script setup>
import AboutCardComponent from '@/components/cards/AboutCardComponent.vue';
import { ref } from 'vue';
import ContactFormComponent from '@/components/ContactFormComponent.vue';
import AppFooter from '@/components/AppFooter.vue';
import NavBar from '@/components/navigation/NavBar.vue';

const steps = ref({
  register: [
    'Register or Login',
    'Fill in the submit link form with your entity details',
    'Submit your link & wait for approval',
  ],
  voting: [
    'You can also vote for links shared by other if you know about theme',
    'Comment for additional infos',
    'submit missing image',
  ],
  contact: [
    'If a link interest you click on to view more.',
    'Or click on the link website address or email to get directly in touch with the entity',
  ],
});
</script>

<template>
  <NavBar />
  <div class="min-h-full relative py-20">
    <div
      class="h-full absolute w-full top-0 left-0 -z-20 blur-sm"
      style="
        background-image: url('https://images.unsplash.com/photo-1563382454-400a632d7c4e?q=80&w=3874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');
        background-attachment: fixed;
        background-size: cover;
        background-position: center center;
        background-color: #2c3e50;
      "
    />
    <div />
    <div class="container md:max-w-6xl mx-auto px-4">
      <div class="">
        <AboutCardComponent />
      </div>
      <div class="my-10">
        <h2 class="text-green-50 font-bold text-4xl mb-3 drop-shadow-sm">
          How it works
        </h2>
        <div>
          <ul
            class="flex flex-wrap md:flex-nowrap justify-between items-stretch md:space-x-5"
          >
            <li
              v-for="(step, index) in steps"
              :key="index"
              class="w-full md:w-6/12 mb-2 rounded-xl py-3 text-center flex flex-col items-center min-h-full"
            >
              <h3
                class="px-3 font-bold pb-2 pt-4 rounded-t-xl text-lg text-green-100 capitalize w-full drop-shadow-sm"
                style="
                  backdrop-filter: blur(10px);
                  background-color: rgba(200, 200, 200, 0.3);
                "
              >
                {{ index }}
              </h3>
              <ul class="h-full bg-white rounded-b-lg pt-2 text-justify">
                <li
                  v-for="(item, index2) in step"
                  :key="index2"
                  class="px-3 text-sm text-gray-600 w-full mb-4 list-disc list-inside"
                  :class="[step.length - 1 === index2 ? 'rounded-b-xl' : '']"
                  style="
                  backdrop-filter: blur(100%);
                  background-color: rgba(255, 255, 255, .8);
                "
                >
                  {{ item }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <ContactFormComponent />
    </div>
  </div>
  <AppFooter />
</template>

<style scoped></style>
